import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/riders/categories', { params })
  },
  store (formData) {
    return apiClient.post('/riders/categories', formData)
  },
  show (id, params) {
    return apiClient.get(`/riders/categories/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/riders/categories/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/riders/categories/${id}`)
  }
}
